import * as React from "react";
import {
  InformationWrapper,
  LargeInformationWrapper,
  LowerRowWrapper,
  Separator,
  SummaryElementWrapper,
} from "src/components/Summary/SummaryElement/SummaryElement.components";
import { TaskSummaryModel } from "src/socket/events/GameSummary/taskSummary.model";

interface SummaryElementProps {
  summary: TaskSummaryModel;
  name: string;
}

const SummaryElement: React.FunctionComponent<SummaryElementProps> = ({
  summary,
  name,
}) => {
  const { avgScore, agreementScore, finalResult } = summary;

  return (
    <>
      <SummaryElementWrapper>
        <LargeInformationWrapper>
          <h4>Task name</h4>
          <h3>{name}</h3>
        </LargeInformationWrapper>
        <LowerRowWrapper>
          <InformationWrapper>
            <h4>Average</h4>
            <h3>{avgScore}</h3>
          </InformationWrapper>
          <InformationWrapper>
            <h4>Agreement</h4>
            <h3>{`${agreementScore}%`}</h3>
          </InformationWrapper>
          <InformationWrapper>
            <h4>Final result</h4>
            <h3>{finalResult}</h3>
          </InformationWrapper>
        </LowerRowWrapper>
      </SummaryElementWrapper>
      <Separator />
    </>
  );
};

export default SummaryElement;
